export default "__VITE_ASSET__b415def7__"